import React from 'react'
import DebugInfoForm from './Ui/Blocks/DebugInfoForm'

const SendDebugInfo = () => {
  return <DebugInfoForm />
}

export default SendDebugInfo
